// extracted by mini-css-extract-plugin
export default {"label":"Tab_label__vtOL-","container":"Tab_container__zCG2C","containerHover":"Tab_containerHover__ywKAy"};